import { Component, Input } from '@angular/core';
import { TimeLineListComponent } from '../time-line-list/time-line-list.component';
import { Subscription } from 'rxjs';
import { ClientModel } from 'src/app/core/models/members/client/client.model';
import { TimelineModel } from 'src/app/core/models/timeline/timeline.model';
import { LoginType } from 'src/app/core/models/members/user/user-context.model';
import { OwnerEntityType } from 'src/app/core/enums/owner-entity-type-enum';
import { TimeLineType } from 'src/app/core/enums/timeline-type-enum';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { TimeLineListService } from 'src/app/core/services/list-services/time-line-list.service';
import { ServiceData } from 'src/app/core/models/table/service-data.model';
import { TableConfigurationModel } from 'src/app/core/models/table/table-configuration.model';
import { ContactListTableConfig } from '../contact-list/configs/table-contact-list.config';
import { TimelineListTableConfig } from '../time-line-list/time-line-list.config';
import { SortByTypeEnum } from 'src/app/core/enums/list-layout/sort-type-enum';
import { EmitSortModel } from 'src/app/core/models/table/emit-sort.model';
import { NgSelectListModel } from 'src/app/core/models/ng-select-list.model';
import { ButtonIdEnum } from 'src/app/core/enums/list-layout/button-id-enum';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { Roles } from 'src/app/core/security/roles';

@Component({
  selector: 'app-timeline-note-list',
  templateUrl: './timeline-note-list.component.html',
  styleUrls: ['./timeline-note-list.component.scss'],
  providers: [TimeLineListService]
})
export class TimelineNoteListComponent extends TimeLineListComponent {

  @Input() timelineType?: TimeLineType = undefined;
  @Input() public displayClientBase: boolean = false;
  @Input() public displayFilterType: boolean = false;
  @Input() public displayFilterOwner: boolean = false;
  @Input() public customTitle?: string = undefined;

  tableConfig: TableConfigurationModel = new TableConfigurationModel();
  serviceData: ServiceData = new ServiceData();

  override ngOnInit(): void {

    this.listItemsObservable = this.timeLineListService.resultItems$;
    this.total = this.timeLineListService.total$;
    this.isLoading = this.timeLineListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true;
      } else {
        this.serviceData.loadingValue = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
      this.listItems.forEach((timelineModel: TimelineModel) => {
        if (timelineModel.clientBase && timelineModel.clientBase.id && timelineModel.clientBase.profilePhotoFileId) {
          this.getEntityPhoto(timelineModel.clientBase, EntityTypeEnum.Client);
        }
        if (timelineModel.owner && timelineModel.owner.id && timelineModel.owner.profilePhotoFileId) {
          this.getEntityPhoto(timelineModel.owner, EntityTypeEnum.User);
        }
      });

    });
    this.unsubscribe.push(subscr2);

    const subscr3 = this.total.subscribe(result => {
      this.serviceData.totalRecords = this.timeLineListService.totalRecords;
      this.serviceData.pageSize = this.timeLineListService.pageSize;
      this.serviceData.pageIndex = this.timeLineListService.pageIndex;
    });
    this.unsubscribe.push(subscr3);

    this.tableConfig = new TimelineListTableConfig();

    this.timeLineListService.ownerId = this.timelineOwnerId;

    if (this.displayClientBase === true && this.tableConfig.columns) {
      this.tableConfig.columns[1].visible = 'true';
    }

    if (this.displayFilterType === false && this.tableConfig.filters) {
      this.tableConfig.filters[1].isHidden = true;
    }

    if (this.displayFilterOwner === false && this.tableConfig.filters) {
      this.tableConfig.filters[0].isHidden = true;
    }

    if (this.customTitle && this.tableConfig.listTitle) {
      this.tableConfig.listTitle = this.customTitle;
    }

    if (this.timelineType != undefined) {
      this.timeLineListService.types = [this.timelineType];
    }

    if (this.ownerType != undefined) {
      if (this.securityPermissionTimelineReadAll && this.tableConfig.filters) {
        this.tableConfig.filters[0].options.push(new NgSelectListModel(OwnerEntityType.User, $localize`:@@:User`, undefined));
      }
      this.timeLineListService.ownerEntityType = [this.ownerType];
    }

    if (this.createdByUser) {
      this.timeLineListService.createdById = this.authMyFileService.currentUserContextValue?.id;
    }

  }

  openModal(timelineItemModel: TimelineModel, disableModel: boolean, display: OwnerEntityType | undefined, otherModel?: any) {
    this.TimelineNoteModalService.openModal(timelineItemModel, disableModel, display, otherModel);
    var sub: Subscription = this.TimelineNoteModalService.modelChanged.subscribe((result: any) => {
      if (result) {
        this.timeLineListService.startIndex = this.timeLineListService.startIndex;
      }
      sub.unsubscribe();
    })
  }

  newNote() {
    var newTimeLineModel = new TimelineModel();
    if (this.timelineOwnerId) {
      newTimeLineModel.ownerEntityType = this.ownerType;
      newTimeLineModel.type = TimeLineType.Note;
      newTimeLineModel.ownerId = this.timelineOwnerId;

      switch (this.ownerType) {
        case OwnerEntityType.Client:
          this.myFileApiService.getClient(this.timelineOwnerId).subscribe((client: ClientModel | undefined) => {
            this.TimelineNoteModalService.openModal(newTimeLineModel, false, OwnerEntityType.Client, client);
            var sub: Subscription = this.TimelineNoteModalService.modelChanged.subscribe((result: any) => {
              if (result) {
                this.timeLineListService.startIndex = this.timeLineListService.startIndex;
              }
              sub.unsubscribe();
            });
          });
          break;
        default:
          this.TimelineNoteModalService.openModal(newTimeLineModel, false, this.ownerType);
          var sub: Subscription = this.TimelineNoteModalService.modelChanged.subscribe((result: any) => {
            if (result) {
              this.timeLineListService.startIndex = this.timeLineListService.startIndex;
            }
            sub.unsubscribe();
          });
          break;
      }


    } else {
      newTimeLineModel.type = TimeLineType.Note;
      if (this.loginType == LoginType.Client) {
        newTimeLineModel.ownerId = this.authMyFileService.currentUserContextValue?.id;
        this.TimelineNoteModalService.openModal(newTimeLineModel, false, this.ownerType);
        var sub: Subscription = this.TimelineNoteModalService.modelChanged.subscribe((result: any) => {
          if (result) {
            this.timeLineListService.startIndex = this.timeLineListService.startIndex;
            newTimeLineModel = new TimelineModel;
          }
          sub.unsubscribe();
        })
      } else {
        this.TimelineNoteModalService.openModal(newTimeLineModel, false, this.ownerType);
        var sub: Subscription = this.TimelineNoteModalService.modelChanged.subscribe((result: any) => {
          if (result) {
            this.timeLineListService.startIndex = this.timeLineListService.startIndex;
            newTimeLineModel = new TimelineModel;
          }
          sub.unsubscribe();
        })
      }
    }
  }

  sortByPassedSort(passedSortModel: EmitSortModel) {
    if (passedSortModel.sortSelected == SortByTypeEnum.None) {
      this.serviceSort(this.timeLineListService, '', '');
    } else {
      this.serviceSort(this.timeLineListService, passedSortModel.fieldName, passedSortModel.sortSelected);
    }
  }

  clearSearchTerm(service: any) {
    service.searchTerm = undefined;
  }

  override rowActionSelected(rowAction: TableActionsModel): void {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.View:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openNote(rowAction.model, true);
        break;
        
      case ActionIdEnum.Edit:
        if (rowAction.model == undefined || rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openNote(rowAction.model, false);
        break;
    }
  }

  override filterSelected(filterSelected: ListFilterModel): void {
    switch (filterSelected.label) {
      case 'ownerEntityType':
        if (filterSelected.selectedOption !== undefined) {
          this.timeLineListService.ownerEntityType = [filterSelected.selectedOption];
        } else {
          this.timeLineListService.ownerEntityType = undefined;
        }
        break;
      case 'type':
        if (filterSelected.selectedOption !== undefined) {
          this.timeLineListService.types = [filterSelected.selectedOption];
        } else {
          this.timeLineListService.types = undefined;
        }
        break;
    }
  }
  override buttonActionSelected(buttonAction: any): void {
    var action = buttonAction;

    if (buttonAction.buttonId !== undefined) {
      action = buttonAction.buttonId
    }

    switch (action) {
      case ButtonIdEnum.CreateNew:
        this.newNote()
        break;
    }
  }
}
